import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt, faCoffee, faMedal } from "@fortawesome/free-solid-svg-icons";
import 'react-responsive-modal/styles.css';
import { withTranslation } from 'react-i18next';

class CardHotel extends React.Component {
    constructor (props) {
        super(props);
        /*this.state = {
            'active' : false,
            'open': false,
			'open_covid19': false,
            'data': this.props.data,
            'property_photo': null
        }*/
        //this.handleClick = this.handleClick.bind(this); 
        //this.handleMoreDetailsBtn = this.handleMoreDetailsBtn.bind(this); 
    }

    componentDidMount() {
        // initGA();
     }

    GetMealPlanName = (code) => {
        const { t } = this.props;
        switch(code) {
          case 'HM': return t('hotel.mealPlans.halfBoard'); // Breakfast and half board
          case 'MB': return t('hotel.mealPlans.halfBoardWithDrinks'); //Half board with drinks
          case 'MP': return t('hotel.mealPlans.halfBoard'); //Half board
          case 'PC': return t('hotel.mealPlans.fullBoard'); //Full board
          case 'PV': return t('hotel.mealPlans.fullBoardWithDrinks'); //Full board with drinks
          case 'SA': return ''; //Accommodation only
          case 'SP': return ''; //According to programme
          case 'TI': return t('hotel.mealPlans.allInclusive'); //All inclusive
          case 'TP': return t('hotel.mealPlans.allInclusivePremium'); //All inclusive premium
          case 'SC': return ''; //Self Catering
          case 'HD': return t('hotel.mealPlans.breakfast'); //Bed and breakfast
          default: return '';
        }
    };


     render() {
         const { t } = this.props;
         //console.log(this.props.data)
        //const backgroundImage = `../images/destinations/${this.props.data.property.city_name}.jpg`; //this.props.data.destination.city_id; //encodeURI(this.props.data.image);
        const hotel_name = this.props.data.property.name
        let hotel_address = this.props.data.property.address
        if (hotel_address.length > 35)
            hotel_address = hotel_address.substring(0,30) + '...'
        const stars_count = this.props.data.property.stars
        let distance_from_center = Number(this.props.data.property.distance_from_center).toFixed(1) + ' ' + t('common.units.km')
        if (Number(this.props.data.property.distance_from_center)<1)
            distance_from_center = Number(this.props.data.property.distance_from_center)*1000 + ' ' + t('common.units.meters')
        //const hotel_stars_caption = this.props.data.property.stars +' כוכבים'        

        return ( 
            <div  style={{textAlign:'right', color:'#333', direction:'ltr', padding: '0.8em', width:'100%', backgroundColor:'#eee'}}>
                {/*<h3 style={{fontSize:'1.35em', fontWeight:800}}>מלון {hotel_stars_caption}</h3>*/}
                <div style={{display:'flex', flexDirection: 'column'}}>
                    <h4 style={{fontSize:'1.1em', lineHeight:1, margin:'0 0 0.5em', maxWidth:'220px', textAlign:'left'}}>{hotel_name}</h4>
                    {/*<p style={{color:'#777',maxWidth:'90%', lineHeight:1, fontSize: '0.8em', fontWeight:400}}>{hotel_address}</p>*/}
                    <div style={{display:'flex', justifyContent: 'space-between'}}>
                        <div className='hotelPhoto' style={{backgroundImage: "url(" + (this.props.data.property.photos?`https://cdn.cookiecrumbz.com/images/properties/400/${this.props.data.property.photos[0]}`:'') + ")"}}></div>
                        <div style={{direction: 'rtl', width:'100%', paddingLeft:'0.25em', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'}}>
                            <div className="stars" style={{color:'#daa520', fontSize: '1.2em'}}>{this.getStarsImage(stars_count)}</div>
                            <div className={this.props.data.property.room.breakfast_included?'':'hidden'}>
                                <div style={{fontSize:'0.9em', display:'inline-block', color: '#02badb', fontWeight: 700}} className={'div_breakfast ' + (this.GetMealPlanName(this.props.data.property.meal_code)!==''?'':'hide')}>
                                <FontAwesomeIcon icon={faCoffee} style={{display:'inline-block', margin:'0 0 0 .3em', fontSize:'0.9em'}} /> 
                                 {this.GetMealPlanName(this.props.data.property.meal_code)} </div>
                            </div>
                            <div>
                                <FontAwesomeIcon icon={faMapMarkerAlt} style={{display:'inline-block', margin:'0 .2em 0 .3em', fontSize:'0.9em'}} />
                                <div style={{fontSize:'0.9em', display:'inline-block'}}>{distance_from_center} {t('hotel.fromCenter')}</div>
                            </div>
                            <div className={this.props.data.property.room.breakfast_included?'hidden':''}>
                                <FontAwesomeIcon icon={faMedal}  style={{display:'inline-block', margin:'0 .2em 0 .3em', fontSize:'0.85em'}}  />
                                <div style={{fontSize:'0.9em', display:'inline-block'}}> {t('hotel.features.popular')}</div>
                            </div>
                        </div>
                    </div>
                </div>
                

            </div> 
        )
     }

     getStarsImage(num) {
        let output = "";

        for (let i=0;i<num;i++) {
            output+="★";
        }

        return output;
    }

}

export default withTranslation()(CardHotel)